// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3vomk","right":"Footer_right__hU7d5","buttons":"Footer_buttons__3hQu_"};